namespace Solovis.Site.RequestNewInvestment {

  export interface NewInvestmentRequest {
    fileUpload: File[];
    holdingEntityId: number;
    name: string;
    newEntity: any;
    ownerEntityId: number;
    propertyValues: any[];
  }

  export interface AjaxError {
    status: number;
    statusText: string;
    responseText: string;
  }

  export interface NewInvestmentResult {
    error: any;
    errors: any;
    result: boolean;
  }

  export interface NewInvestmentRequest {
    fileUpload: File[];
    holdingEntityId: number;
    name: string;
    newEntity: any;
    ownerEntityId: number;
    propertyValues: any[];
  }

  export interface AjaxError {
    status: number;
    statusText: string;
    responseText: string;
  }

  export interface NewInvestmentResult {
    error: any;
    errors: any;
    result: boolean;
  }
  export class RequestNewInvestmentDialog {
    public investmentEditor: Solovis.Site.RequestNewInvestment.RequestNewInvestmentControl;
    public _dialogWindow: Solovis.UI.Dialog;

    constructor() {
      var self = this;

      var desiredWidth = Math.min($(window).width() * .8, 750);
      var desiredHeight = Math.min($(window).height() * .8, 800);

      var minWidth = 100;
      var minHeight = 100;

      var editorDiv = $("<div>")
        .css("min-height", "75px");

      this.investmentEditor = new Solovis.Site.RequestNewInvestment.RequestNewInvestmentControl({
        controlHost: editorDiv,
      });

      this.investmentEditor.setAsCurrentControl();

      this._dialogWindow = new Solovis.UI.Dialog({
        container: editorDiv,

        title: "New Investment Request",

        modal: true,
        center: true,
        actions: ["Close"],
        autoOpen: true,
        destroyOnClose: true,
        width: desiredWidth,
        height: desiredHeight,
        minWidth: minWidth,
        minHeight: minHeight,
        buttons: [
          {
            label: "Send",
            click: function () {
              self._send();
            },
          },
          {
            label: "Cancel",
            click: function () {
              self._dialogWindow.close();
            }
          }
        ],

        activate: function () {
          self.investmentEditor.focus();
        }
      });
    }


    public _cancel() {
      this._dialogWindow.close();
    }

    public _send() {
      var self = this;

      // useing this to flatten FormData so c# can understand it
      const flatten = (object: Object, path: string, isArray?: boolean): Array<[string, string]> => {
        return Object.keys(object).reduce((prev, key) => {
          const newPath = isArray ? `${path}[${key}]` : `${path}.${key}`;
          return typeof object[key] === "object" ? [...prev, ...flatten(object[key], newPath, object[key] instanceof Array)] : [...prev, [newPath, object[key]]]
        }, []);
      }

      if (this.investmentEditor.isValid()) {
        const getFormData = (object: NewInvestmentRequest) => Object.keys(object).reduce((formData, key) => {
          if (key === "fileUpload") {
            for (const file of object[key]) {
              formData.append("fileInput[" + file.name + "]", file);
            }
          } else {
            if (typeof (object[key]) === "object") {
              const flat = flatten(object[key], key, object[key] instanceof Array);
              flat.map(([key, value]) => formData.append(key, value));
            }
            else {
              formData.append(key, object[key]);
            }
          }
          return formData;
        }, new FormData());

        var newInvestmentRequest = this.investmentEditor.getInvestmentModel();

        const formData = getFormData(newInvestmentRequest);

        if ((Solovis as any).Info.csrfToken) {
          formData.append("X-SOLOVIS-CSRF", (Solovis as any).Info.csrfToken);
        }

        $.ajax({
          url: "/DataImports/SpreadsheetTemplate/SendNewInvestmentSpreadsheet",
          type: 'POST',
          // Ajax events
          success: function (data: NewInvestmentResult) {
            if (data.result) {
              self.investmentEditor.clearNotification();
              self._dialogWindow.close();
            } else if (data.error) {
              self._handleError(data.error);
            } else if (data.errors) {
              data.errors.each(function (index, error: any) {
                self._handleError(error);
              });
            }
          },
          error: function (e: AjaxError) {
            self.investmentEditor.notify({
              success: false,
              message: e.responseText.split("\r\n")[0],
            });
          },
          beforeSend: function (xhr) {
            xhr.setRequestHeader("X-POST-RPC", "true");
          },
          // Form data
          data: formData,
          // Options to tell jQuery not to process data or worry about content-type.
          cache: false,
          contentType: false,
          processData: false
        });
      }
    }

    private _handleError(error: any)
    {
      if (error.propertyName !== "name") {
        this.investmentEditor.notify({
          success: false,
          message: error.message
        });
      }
      else {
        var nameEntry = this.investmentEditor._formBuilder.getEntryByName("name");
        nameEntry.showEntry(true);
        nameEntry.validationModel.setErrorMessage(error.message);
      }
    }
  }
}
